/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Corpus_CappedInputs */



/**
* | output |
* | --- |
* | "Corpus capped — the connection lists more items than the sync ceiling; older items are kept but no longer reconciled. Narrow the connection scope to restore ..." |
*
* @param {Sync_Degraded_Corpus_CappedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_corpus_capped = /** @type {((inputs?: Sync_Degraded_Corpus_CappedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Corpus_CappedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Korpus gedeckelt — die Verbindung listet mehr Elemente als die Sync-Obergrenze; ältere Elemente bleiben erhalten, werden aber nicht mehr abgeglichen. Verbindungsumfang einschränken, um vollen Sync wiederherzustellen.")
	return /** @type {LocalizedString} */ ("Corpus capped — the connection lists more items than the sync ceiling; older items are kept but no longer reconciled. Narrow the connection scope to restore full sync.")
});